import React, { useState, useEffect } from "react";
import { db } from "../../utils/firebase";
import LeaderBackground from "../../img/leaderbrd_bckgrnd.png"
import pressedAT from "../../img/bttn_alltime2.png"
import unpressedAT from "../../img/bttn_alltime1.png"
import pressedPH from "../../img/bttn_pasthr2.png"
import unpressedPH from "../../img/bttn_pasthr1.png"
import blueBg from "../../img/leaderbrd_blue.png"
import bg from "../../img/leaderbrd_bckgrnd.png"
import one from "../../img/Medal1.png"
import two from "../../img/Medal2.png"
import three from "../../img/Medal3.png"
import rectangle from "../../img/completionBar.png"
import stopwatch from "../../img/stopwatch.png"
import timebar from "../../img/timeBar.png"
import top10AllTime from "../../img/playerAT.png"
import top10APastHour from "../../img/playerPH.png"
import top5AT from "../../img/leaderbrd-alltime1.png"
import top5PH from "../../img/leaderbrd-pasthr1.png"
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  limit,
  where,
  Timestamp,
  getDocs,
  deleteDoc,
  doc
} from "firebase/firestore";

const LeaderboardsPage = () => {
  const [topPlayers, setTopPlayers] = useState([]);
  const [recentTopPlayers, setRecentTopPlayers] = useState([]);
  const [currentLeaderboard, setCurrentLeaderboard] = useState("recent"); // "overall" or "recent"

  // Password state
  const [enteredPassword, setEnteredPassword] = useState("");
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);
  const [passwordError, setPasswordError] = useState(""); // To show error message

  // Predefined password for reset
  const RESET_PASSWORD = "blmfmixqzl5"; // Change this to your desired password

  useEffect(() => {
    const topPlayersQuery = query(
      collection(db, "leaderboard"),
      orderBy("timeSpent"),
      limit(10)
    );

    const recentTopPlayersQuery = query(
      collection(db, "leaderboard"),
      where(
        "completionDateTime",
        ">=",
        Timestamp.fromDate(new Date(Date.now() - 60 * 60 * 1000))
      ), // 1 hour ago
      limit(10) // Limit for recent players
    );

    // Real-time listener for top players
    const unsubscribeTopPlayers = onSnapshot(topPlayersQuery, (snapshot) => {
      const leaderboardData = snapshot.docs.map((doc) => doc.data());
      setTopPlayers(leaderboardData);
    });

    // Real-time listener for recent players
    const unsubscribeRecentTopPlayers = onSnapshot(
      recentTopPlayersQuery,
      (snapshot) => {
        const recentLeaderboardData = snapshot.docs.map((doc) => doc.data());

        // Sort by timeSpent in ascending order to rank by fastest
        recentLeaderboardData.sort((a, b) => a.timeSpent - b.timeSpent);
        setRecentTopPlayers(recentLeaderboardData.slice(0, 10)); // Get top 10
      }
    );

    // Clean up the listeners when the component unmounts
    return () => {
      unsubscribeTopPlayers();
      unsubscribeRecentTopPlayers();
    };
  }, []);

  const formatCompletionDateTime = (completionDateTime) => {
    if (completionDateTime && completionDateTime.seconds) {
      const date = new Date(completionDateTime.seconds * 1000);
      return date.toLocaleString();
    } else {
      return "N/A";
    }
  };

  // Reset leaderboard function with password validation
  const resetLeaderboard = async () => {
    if (enteredPassword !== RESET_PASSWORD) {
      // Show error message if password is wrong
      setPasswordError("Incorrect password. Reset operation aborted.");
      setEnteredPassword(""); // Clear the password field
      return; // Don't proceed with the reset
    }

    try {
      const leaderboardRef = collection(db, "leaderboard");
      const querySnapshot = await getDocs(leaderboardRef);

      // Delete all documents in the leaderboard collection
      querySnapshot.forEach(async (docSnapshot) => {
        await deleteDoc(doc(db, "leaderboard", docSnapshot.id));
      });

      // Optionally, you can show a confirmation or notification
      alert("Leaderboard has been reset!");
      setEnteredPassword(""); // Clear password field after reset
      setShowPasswordPrompt(false); // Hide password prompt after successful reset
      setPasswordError(""); // Clear any previous errors
    } catch (error) {
      console.error("Error resetting leaderboard: ", error);
      alert("Failed to reset leaderboard.");
    }
  };

  // Handle password prompt visibility
  const handleResetButtonClick = () => {
    setShowPasswordPrompt(true); // Show password input when reset button is clicked
    setPasswordError(""); // Reset error message when prompt is shown
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      {/* Buttons to switch between leaderboards */}
      {/* <div className="flex flex-col space-y-4 w-full sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4 items-center" style={{position:"absolute", marginBottom: "310px"}}> */}
      {/* <div className="flex flex-row w-full justify-center -mt-40 mb-40 pb-80 space-x-4 items-center absolute"> */}
      <div className="flex flex-row w-full justify-center space-y-0 space-x-4 items-center" style={{position:"absolute", marginBottom: "604px"}}>
        <button
          className={`w-full sm:w-auto px-4 py-2 rounded-lg text-lg font-semibold transition duration-200 ${
            currentLeaderboard === "recent"
              ? "bg-blue-500 text-white"
              : "bg-gray-300 text-black"
          }`}
          style={{ backgroundImage: currentLeaderboard === "recent" ? `url(${pressedPH})` : `url(${unpressedPH})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' , fontSize: currentLeaderboard === "overall" ? "0" : "0", width: 168}}
          onClick={() => setCurrentLeaderboard("recent")}
        >
          Top 10 Past Hour
        </button>
        <button
          className={`w-full sm:w-auto px-4 py-2 rounded-lg text-lg font-semibold transition duration-200 ${
            currentLeaderboard === "overall"
              ? "bg-blue-500 text-white"
              : "bg-gray-300 text-black"
          }`}
          style={{ backgroundImage: currentLeaderboard === "overall" ? `url(${pressedAT})` : `url(${unpressedAT})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' , fontSize: currentLeaderboard === "overall" ? "0" : "0", width: 168}}
          onClick={() => setCurrentLeaderboard("overall")}
        >
          Top 10 All Time
        </button>
      </div>

      {/* Leaderboard Card */}
      <div className="w-full max-w-full sm:max-w-3xl p-4 sm:p-6 rounded-3xl shadow-lg" style={{background: `url(${blueBg}`}}>
        <h2 className="text-xl sm:text-2xl font-bold p-4 text-center" style={{ color: "white", fontSize: "0%", backgroundImage: currentLeaderboard === "recent" ? `url(${top10APastHour})` : `url(${top10AllTime})`, backgroundRepeat: "no-repeat", backgroundSize: "70%", backgroundPosition: "center"}}>
          {currentLeaderboard === "recent"
            ? "Top 10 Players in the Past Hour"
            : "The Best Top 10 Players All Time"}
            
        </h2>
        <div className="overflow-x-auto" style={{height: '490px', overflowY: 'scroll', scrollbarColor: 'white transparent'}} >
          <table className="min-w-full text-sm sm:text-base">
            
            <tbody>
            {currentLeaderboard === "overall" &&
                topPlayers.map((player, index) => {
                  let rankImage;
                  let style = {};
                  if (index === 0) {
                    rankImage = one; 
                  } else if (index === 1) {
                    rankImage = two; // 
                  } else if (index === 2) {
                    rankImage = three;
                  } else {
                    rankImage = null;
                  }

                  return (
                    <tr key={index} className="text-center">
                       <td
                        className="py-6 px-4"
                        style={{
                          backgroundImage: rankImage ? `url(${rankImage})` : "none", 
                          backgroundSize: "50px",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          fontSize: rankImage ? "0" : "200%",
                          fontWeight: rankImage ? "normal" : "bold",
                          textAlign: "center", 
                          lineHeight: "50px", 
                          color: rankImage ? "transparent" : "white",
                          width: "3.5rem"
                        }}
                      >
                        {index + 1}

                      </td>


                      <td
                        className="py-9 px-2 bg-center lg:bg-center text-[13px] md:text-[18px] lg:text-[18px]"
                        style={{
                          backgroundImage: `url(${rectangle})`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "124% 54%",
                          // backgroundPosition: "center",                   
                          // fontSize: "18px",
                          marginLeft: "5px",
                          backgroundPositionY: "22px",
                          justifyContent: "space-between",
                          display: "flex",
                        }}
                      >
                        <span style={{ fontWeight: "bold", textAlign: "left", display: "inline-block", maxWidth: "calc(10ch)", wordWrap: "break-word",}}>{player.name.length > 10 ? player.name.slice(0, 10) : player.name}</span>
                        <span style={{ textAlign: "right" }}>{player.timeSpent} seconds</span>
                      </td>

                      <td
                        className="py-3 px-4 hidden sm:table-cell"
                        style={{
                          backgroundImage: `url(${timebar})`,
                          backgroundSize: "94%",
                          color: "white",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                      >
                        {formatCompletionDateTime(player.completionDateTime)}
                      </td>
                    </tr>
                  );
                })}

              {currentLeaderboard === "recent" &&
                (recentTopPlayers.length > 0 ? (
                  recentTopPlayers.map((player, index) => {
                    let rankImage;
                    let style = {};
                    if (index === 0) {
                      rankImage = one; 
                    } else if (index === 1) {
                      rankImage = two; // 
                    } else if (index === 2) {
                      rankImage = three;
                    } else {
                      rankImage = null;
                    }

                    return (
                      <tr key={index} className="text-center">
                         <td
                          className="py-6 px-4"
                          style={{
                            backgroundImage: rankImage ? `url(${rankImage})` : "none", 
                            backgroundSize: "50px",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            fontSize: rankImage ? "0" : "200%",
                            fontWeight: rankImage ? "normal" : "bold",
                            textAlign: "center", 
                            lineHeight: "50px", 
                            color: rankImage ? "transparent" : "white",
                            width: "3.5rem"
                          }}
                        >
                          {index + 1}
  
                        </td>
  
  
                        <td
                          className="py-9 px-2 bg-center lg:bg-center text-[13px] md:text-[18px] lg:text-[18px]"
                          style={{
                            backgroundImage: `url(${rectangle})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "124% 54%",
                            // backgroundPosition: "center",                   
                            // fontSize: "18px",
                            marginLeft: "5px",
                            backgroundPositionY: "22px",
                            justifyContent: "space-between",
                            display: "flex",
                          }}
                        >
                          <span style={{ fontWeight: "bold", textAlign: "left", display: "inline-block", maxWidth: "calc(10ch)", wordWrap: "break-word",}}>{player.name.length > 10 ? player.name.slice(0, 10) : player.name}</span>
                          <span style={{ textAlign: "right" }}>{player.timeSpent} seconds</span>
                        </td>

                        <td
                        className="py-3 px-4 hidden sm:table-cell"
                        style={{
                          backgroundImage: `url(${timebar})`,
                          backgroundSize: "94%",
                          color: "white",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                      >
                        {formatCompletionDateTime(player.completionDateTime)}
                      </td>
                    </tr>
                  );
                  })
                ) : (
                  <tr>
                    <td className="py-3 px-4 text-center py-56" colSpan={4}>
                      No players in the past hour.
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Reset Button */}
      <button
        onClick={handleResetButtonClick}
        className="absolute bottom-2 right-2 text-white p-1 rounded-full shadow-lg transition duration-300"
        style={{ fontSize: '8px' }}
      >
        Reset Leaderboard
      </button>

      {/* Password Prompt */}
      {showPasswordPrompt && (
        <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-2xl font-bold mb-4">Enter Password to Reset</h2>
            <input
              type="password"
              className="border p-2 w-full mb-4"
              placeholder="Enter password"
              value={enteredPassword}
              onChange={(e) => setEnteredPassword(e.target.value)}
            />
            {passwordError && (
              <div className="text-red-500 text-sm mb-4">{passwordError}</div>
            )}
            <div className="flex justify-between">
              <button
                onClick={() => setShowPasswordPrompt(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
              <button
                onClick={resetLeaderboard}
                className="bg-red-500 text-white px-4 py-2 rounded-lg"
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardsPage;
